import React from 'react';
import InteractiveImage from "../../images/mobile/image-interactive.jpg"
import { Container, ImageInteractive, TextAbout, Leader,TextArea } from './styles';

function WordBest() {
  return (
    <Container>
        <ImageInteractive src = {InteractiveImage}/>
        <TextArea>
          <Leader>The Leader in interactive vr</Leader>
          <TextAbout>
              Founded in 2011,Loopstudios has been producing word-class virtual reality projects for some of the best companies around the globe. Our award-winning creations have transformed businesses throught digital experiences that bind to their brand.
          </TextAbout>
        </TextArea>
    </Container>
  );
}

export default WordBest;